(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-regina"]) return;
  try {
    
  /* Regina — StickyHeader (Dawn-compatible custom element) */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this._headerResizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        const h = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      });
      this._headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      /* On mobile, wire resize so we can re-evaluate always-sticky logic */
      window.matchMedia('(max-width: 989px)').addEventListener('change', () => {
        if (this.headerIsAlwaysSticky && window.innerWidth >= 990) {
          this.header.classList.remove('shopify-section-header-hidden');
          this.header.classList.add('shopify-section-header-sticky');
        }
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();

      /* Enforce correct header state on load — scroll events don't fire on page load
         so onScroll won't run at scrollY=0. Double-rAF lets the browser settle its
         scroll position (first-frame scrollTop can be transiently non-zero on some
         browsers). --rh-init is set at the end so the CSS guard lifts at exactly the
         right moment, regardless of when ResizeObserver fires. */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > 0) {
            this.header.classList.add('scrolled-past-header');
          } else {
            this.header.classList.remove('scrolled-past-header');
          }
          document.documentElement.style.setProperty('--rh-init', '1');
        });
      });
    }

    disconnectedCallback() {
      if (this._headerResizeObserver) this._headerResizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    get isMobile() { return window.innerWidth < 990; }

    hide() {
      /* Desktop always-sticky: never hide. Mobile: hide on scroll-down. */
      if (this.headerIsAlwaysSticky && !this.isMobile) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky && !this.isMobile) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky && !this.isMobile) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* Regina — Mobile drawer (sub-menu slide) */
  class ReginaDrawer {
    constructor() {
      this.drawer = document.getElementById('rh-mobile-drawer');
      if (!this.drawer) return;
      /* Move to body to escape section group stacking context / transform containment */
      document.body.appendChild(this.drawer);
      this.burgers   = document.querySelectorAll('.rh-burger');
      this.closeBtn  = this.drawer.querySelector('.rh-drawer__close');
      this.overlay   = this.drawer.querySelector('.rh-drawer__overlay');
      this.mainView  = document.getElementById('rh-drawer-main');
      this.bindEvents();
    }

    bindEvents() {
      this.burgers.forEach(function(btn) {
        btn.addEventListener('click', this.open.bind(this));
      }, this);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
      if (this.overlay)  this.overlay.addEventListener('click', this.close.bind(this));

      /* Open sub-menu */
      this.drawer.querySelectorAll('[data-open-sub]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var subId = btn.getAttribute('data-open-sub');
          this.openSub(subId, btn);
        }.bind(this));
      }, this);

      /* Close sub-menu (back button) */
      this.drawer.querySelectorAll('[data-close-sub]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var subId = btn.getAttribute('data-close-sub');
          this.closeSub(subId);
        }.bind(this));
      }, this);

      /* All .rh-drawer__close buttons (main header + sub-view headers) close the drawer */
      this.drawer.querySelectorAll('.rh-drawer__close').forEach(function(btn) {
        if (btn !== this.closeBtn) btn.addEventListener('click', this.close.bind(this));
      }, this);

      document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape') return;
        var activeSub = this.drawer.querySelector('.rh-drawer__view--sub.rh-view--active');
        if (activeSub) { this.closeSub(activeSub.id); } else { this.close(); }
      }.bind(this));
    }

    open() {
      this.drawer.classList.add('rh-drawer--open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.burgers.forEach(function(b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.classList.add('rh-drawer-open');
      document.body.style.overflow = 'hidden';
      /* Reset any residual panel scroll from previous open */
      var panel = this.drawer.querySelector('.rh-drawer__panel');
      if (panel) { panel.scrollLeft = 0; panel.scrollTop = 0; }
      if (this.closeBtn) requestAnimationFrame(function() { this.closeBtn.focus({ preventScroll: true }); }.bind(this));
    }

    close() {
      /* Reset any open sub-menu instantly */
      this.drawer.querySelectorAll('.rh-drawer__view--sub.rh-view--active').forEach(function(s) {
        s.classList.remove('rh-view--active');
        s.setAttribute('aria-hidden', 'true');
      });
      if (this.mainView) this.mainView.classList.remove('rh-view--pushed');

      this.drawer.classList.remove('rh-drawer--open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.burgers.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.classList.remove('rh-drawer-open');
      document.body.style.overflow = '';
      if (this.burgers[0]) this.burgers[0].focus();
    }

    openSub(subId, triggerBtn) {
      var sub = document.getElementById(subId);
      if (!sub) return;
      sub.classList.add('rh-view--active');
      sub.setAttribute('aria-hidden', 'false');
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'true');
      if (this.mainView) this.mainView.classList.add('rh-view--pushed');
      /* Focus after transition — preventScroll avoids panel scroll offset bug */
      var backBtn = sub.querySelector('.rh-drawer__back');
      if (backBtn) setTimeout(function() { backBtn.focus({ preventScroll: true }); }, 320);
    }

    closeSub(subId) {
      var sub = document.getElementById(subId);
      if (!sub) return;
      sub.classList.remove('rh-view--active');
      sub.setAttribute('aria-hidden', 'true');
      if (this.mainView) this.mainView.classList.remove('rh-view--pushed');
      /* Reset any panel scroll that the browser may have applied */
      var panel = this.drawer.querySelector('.rh-drawer__panel');
      if (panel) { panel.scrollLeft = 0; panel.scrollTop = 0; }
      /* Return focus to the button that opened this sub */
      var trigger = this.drawer.querySelector('[data-open-sub="' + subId + '"]');
      if (trigger) requestAnimationFrame(function() { trigger.focus({ preventScroll: true }); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { new ReginaDrawer(); });
  } else {
    new ReginaDrawer();
  }

  /* Hero offset margin is managed by hero-regina.liquid — see that file. */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
